type UserStatusCardProps = {
  status: boolean;
  onStatusChange: (status: boolean) => void;
};

export const UserStatusCard = ({
  status,
  onStatusChange,
}: UserStatusCardProps) => (
  <div>
    <h2 className="mt-10 mb-5 label-light-blue-xl">アカウント状態</h2>

    <div className="mb-2 text-xl text-black flex flex-row items-center gap-5">
      <div className="text-xl text-black flex flex-row items-center">
        <input
          type="checkbox"
          className="mr-5 w-4 h-4 accent-blue-600"
          checked={status}
          onChange={() => onStatusChange(true)}
        />
        <label>有効</label>
      </div>
      <div className="text-xl text-black flex flex-row items-center">
        <input
          type="checkbox"
          className="mr-5 w-4 h-4 accent-blue-600"
          checked={!status}
          onChange={() => onStatusChange(false)}
        />
        <label>無効</label>
      </div>
    </div>
  </div>
);
